import React from 'react'
import { sustainable } from '~/data'
import * as st from '~/assets/styl/Sustainable.module.styl'
import { Lazyload } from '~/components'
import bg from '~/assets/img/Menina-e-gato.jpg'
import { useLanguage } from '~/hooks'

export default function Sustainable() {
  const { t } = useLanguage()
  return (
    <section id="Sustentabilidade" className={st.core}>
      <h2>{t('Sustainable.title')}</h2>
      <div>
        <div className={st.text}>
          <div>
            <p>{t('Sustainable.paragraph')}</p>
            <ul>
              {sustainable.map(({ icon }, index) => (
                <li key={index}>
                  <Lazyload type="img" src={icon} width="42" height="42" />
                  {
                    t('SustainableData.sustaible', {
                      returnObjects: true,
                    })[index].name
                  }
                </li>
              ))}
            </ul>
          </div>
        </div>
        <Lazyload src={bg} className={st.bg} />
      </div>
    </section>
  )
}
